<template lang="pug">
  .modal
    button.modal__close-button(
      v-if="isCloseButtonEnable"
      @click="$modal.hideAll"
    )
      v-icon(name="x")

    .modal__body(v-if="isSuccess")
      h2.modal__title
        v-icon.modal__title-icon.modal__title-icon--green(name="check")
        | Ваш заказ успешно оформлен
      h4.modal__sub-title Номер заказа: {{8274562038475}}
      //.modal__check
      //  p Номер заказа: {{}}
      //  p Адрес: {{}}
      //  p Услуга: {{}}
      //  p Вариант услуги: {{}}
      //  p {{personAppeal}}: {{}}
      //  p Дата и время: {{}}
      //  p Количество мест: {{}}
      //  p Оплата: {{}}
      //  p Стоимость: {{}}

      .modal__list-wrapper
        h4.modal__list-title Выберите месенжер для получения подтверждения:
        ul.modal__list
          li.modal__list-item
            a.modal__list-item-link(href="#" target="_blank")
              img.modal__list-item-icon(:src="icon.telegram" alt="telegram icon")
              p Telegram
            p.modal__list-item-spec Для подключения Telegram-бота, отправьте боту номер текущего заказа&nbsp;
              span.number(@click="copyToClipboard" title="Скопировать в буфер обмена") {{8274562038475}}
                v-icon(name="copy")

          li.modal__list-item
            a.modal__list-item-link(href="#" target="_blank")
              img.modal__list-item-icon(:src="icon.whatsapp" alt="whatsapp icon")
              p Whatsapp
            p.modal__list-item-spec Для подключения Whatsapp-бота, отправьте боту номер текущего заказа&nbsp;
              span.number(@click="copyToClipboard" title="Скопировать в буфер обмена") {{8274562038475}}
                v-icon(name="copy")

          li.modal__list-item
            a.modal__list-item-link(href="#" target="_blank")
              img.modal__list-item-icon(:src="icon.viber" alt="viber icon")
              p Viber
            p.modal__list-item-spec Для подключения Viber-бота, отправьте боту номер текущего заказа&nbsp;
              span.number(@click="copyToClipboard" title="Скопировать в буфер обмена") {{8274562038475}}
                v-icon(name="copy")

          li.modal__list-item
            label.modal__list-item-link(for="email")
              img.modal__list-item-icon(:src="icon.email" alt="email icon")
              p Email
            p.modal__list-item-spec.modal__list-item-spec--email
              label(for="email") Введите ваш Email для получения подтверждения на почту
              .modal__list-item-spec-form
                input(type="email" id="email" placeholder="Введите ваш Email")

        button.button.modal__bottom-close-button(:disabled="!isCloseButtonEnable" @click="$modal.hideAll") Закрыть


    .modal__body(v-else)
      h2.modal__title
        v-icon.modal__title-icon.modal__title-icon--red(name="x")
        | Упс. Произошла ошбика
      .modal__body
        span Попробуйте оформить заказ еще раз. Если проблема повторится, свяжитесь с нами по телефону&nbsp;
          a.modal__phone(href="tel:+375297284422") +375 (29) 123-45-67

      button.button.modal__bottom-close-button(@click="$modal.hideAll") Закрыть

</template>

<script>
import {mapGetters} from "vuex";
import telegram from '../assets/png/social/telegram.png'
import whatsapp from '../assets/png/social/whatsapp.png'
import viber from '../assets/png/social/viber.png'
import email from '../assets/png/social/email.png'

export default {
  name: 'CheckoutModal',
  data() {
    return {
      icon: {telegram, whatsapp, viber, email},
      isShowCloseButton: false
    }
  },
  props: {
    isSuccess: {
      type: Boolean,
      required: true,
      default: () => false,
    }
  },
  mounted() {
    setTimeout(() => this.isShowCloseButton = true, 5000);
  },
  destroyed() {
    this.isShowCloseButton = false;
  },
  computed: {
    isCloseButtonEnable() {
      return this.isShowCloseButton && this.isSuccess;
    },
    ...mapGetters('config', {personAppeal: 'getPersonAppeal'})
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText('8274562038475');
    }
  }
}
</script>
